import type { Step8FormInput } from '../../../interfaces';

/**
 * `elementar` and `glas` name their own control; `fahrraddiebstahl` names the UI-only toggle on
 * `Step8Form` that reveals the Gesamtwert input behind `fahrraddiebstahlwert`.
 */
export type ZusatzbausteinKey =
  keyof Pick<Step8FormInput, 'elementar' | 'glas'> | 'fahrraddiebstahl';

export interface ZusatzbausteinCard {
  key: ZusatzbausteinKey;
  title: string;
  description: string;
}

/** The key travels with the card so the template never pairs the two by position. */
export const zusatzbausteinCards: ZusatzbausteinCard[] = [
  {
    key: 'glas',
    title: 'Glasbruch',
    description: 'Fenster, Spiegel und Vitrinen in deiner Wohnung',
  },
  {
    key: 'elementar',
    title: 'Elementarschäden',
    description: 'Überschwemmung, Starkregen, Erdbeben und mehr',
  },
  {
    key: 'fahrraddiebstahl',
    title: 'Fahrraddiebstahl',
    description: 'Diebstahl von Fahrrädern außerhalb der Wohnung',
  },
];
